var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"bordered":false}},[_c('a-table',{attrs:{"rowKey":"rowIndex","bordered":"","columns":_vm.columns,"dataSource":_vm.dataSource,"pagination":_vm.ipagination},on:{"change":_vm.handleTableChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }